export const RETRIEVE_ORGANIZATION_ACCOUNT = 'RETRIEVE_ORGANIZATION_ACCOUNT';

export const ADD_USER_ACCOUNT_BEGIN = 'ADD_USER_ACCOUNT_BEGIN';
export const ADD_USER_ACCOUNT_SUCCESS = 'ADD_USER_ACCOUNT_SUCCESS';
export const ADD_USER_ACCOUNT_FAILURE = 'ADD_USER_ACCOUNT_FAILURE';

export const UPDATE_USER_ACCOUNT_BEGIN = 'UPDATE_USER_ACCOUNT_BEGIN';
export const UPDATE_USER_ACCOUNT_SUCCESS = 'UPDATE_USER_ACCOUNT_SUCCESS';
export const UPDATE_USER_ACCOUNT_FAILURE = 'UPDATE_USER_ACCOUNT_FAILURE';

export const DELETE_USER_ACCOUNT_BEGIN = 'DELETE_USER_ACCOUNT_BEGIN';
export const DELETE_USER_ACCOUNT_SUCCESS = 'DELETE_USER_ACCOUNT_SUCCESS';
export const DELETE_USER_ACCOUNT_FAILURE = 'DELETE_USER_ACCOUNT_FAILURE';

export const RETRIEVE_ALL_USERS = 'RETRIEVE_ALL_USERS';
export const TOGGLE_SHOW_SUBMIT_ADD_USER_RESULT = 'TOGGLE_SHOW_SUBMIT_ADD_USER_RESULT';

export const KEY_FOR_USER_NAME = 'name';
export const KEY_FOR_USER_EMAIL = 'email';
export const KEY_FOR_PASSWORD   = 'password';
export const KEY_FOR_DESIGNATION = 'designation';
export const KEY_FOR_USER_ID = 'userId';



// WEBPACK FOOTER //
// ./src/features/user-management/redux/constants.js